import { MagicLink } from '@thirdweb-dev/wallets';
import { useConnect } from '@thirdweb-dev/react-core';
import { useRef, useEffect, useCallback } from 'react';
import { W as WalletEntryButton, c as useTWLocale, C as Container, I as Img, a as iconSize, p as TextDivider, e as Spinner, M as ModalHeader, S as Spacer, B as Button, u as useCustomTheme, s as spacing, h as fontSize, y as IconButton } from './formElements-1a23858b.browser.esm.js';
import { u as useScreenContext, r as reservedScreens, T as ToolTip, I as InputSelectionUI, g as googleIconUri, f as facebookIconUri, t as twitterIconUri, i as githubIconUri, a as appleIconUri, l as linkedinIconUri, j as bitbucketIconUri, k as gitlabIconUri, n as twitchIconUri, p as discordIconUri, q as microsoftIconUri, v as emailAndPhoneIcon, e as emailIcon, x as phoneIcon } from './Tooltip-9e07d5d0.browser.esm.js';
import styled from '@emotion/styled';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import '@emotion/react';
import '@radix-ui/react-icons';
import 'detect-browser';
import '@radix-ui/colors';
import '@radix-ui/react-tooltip';

function magicLink(config) {
  const emailLoginEnabled = config.emailLogin !== false;
  const smsLoginEnabled = config.smsLogin !== false;
  const oauthProviders = config.oauthOptions?.providers;
  const type = config.type || "auth";
  let icon = emailAndPhoneIcon;
  let iconText = "Email or phone";
  if (emailLoginEnabled && !smsLoginEnabled) {
    icon = emailIcon;
    iconText = "Email";
  }
  if (!emailLoginEnabled && smsLoginEnabled) {
    icon = phoneIcon;
    iconText = "Phone number";
  }
  if (!emailLoginEnabled && !smsLoginEnabled) {
    iconText = "Social login";
  }
  return {
    category: "socialLogin",
    id: MagicLink.id,
    recommended: config?.recommended,
    isHeadless: true,
    meta: {
      ...MagicLink.meta,
      name: iconText,
      iconURL: icon
    },
    create: options => new MagicLink({
      ...options,
      ...config
    }),
    connectUI(props) {
      if (props.modalSize === "wide") {
        return /*#__PURE__*/jsx(MagicConnectionUIScreen, {
          ...props,
          type: type,
          emailLogin: emailLoginEnabled,
          smsLogin: smsLoginEnabled,
          oauthProviders: oauthProviders
        });
      }
      if (props.selectionData === undefined) {
        return /*#__PURE__*/jsx(MagicConnectionUIScreen, {
          ...props,
          type: type,
          emailLogin: emailLoginEnabled,
          smsLogin: smsLoginEnabled,
          oauthProviders: oauthProviders
        });
      }
      return /*#__PURE__*/jsx(MagicConnectingUI, {
        ...props,
        type: type
      });
    },
    // select UI only for auth
    selectUI: config.type === "connect" ? undefined : props => {
      return /*#__PURE__*/jsx(MagicSelectUI, {
        ...props,
        emailLoginEnabled: emailLoginEnabled,
        smsLoginEnabled: smsLoginEnabled,
        oauthProviders: oauthProviders
      });
    },
    isInstalled() {
      return false;
    }
  };
}
const MagicSelectUI = props => {
  const screen = useScreenContext();
  if (props.modalSize === "wide" || screen !== reservedScreens.main && props.modalSize === "compact") {
    return /*#__PURE__*/jsx(WalletEntryButton, {
      walletConfig: props.walletConfig,
      selectWallet: () => props.onSelect(undefined)
    });
  }
  return /*#__PURE__*/jsx(MagicUI, {
    ...props,
    emailLogin: props.emailLoginEnabled,
    smsLogin: props.smsLoginEnabled,
    oauthProviders: props.oauthProviders
  });
};
const MagicUI = props => {
  const cwLocale = useTWLocale().connectWallet;
  const locale = useTWLocale().wallets.magicLink;
  const isEmailEnabled = props.emailLogin !== false;
  const isSMSEnabled = props.smsLogin !== false;
  let placeholder = locale.loginWithEmailOrPhone;
  let type = "text";
  let emptyErrorMessage = locale.emailOrPhoneRequired;
  if (isEmailEnabled && !isSMSEnabled) {
    placeholder = locale.emailPlaceholder;
    emptyErrorMessage = locale.emailRequired;
    type = "email";
  } else if (!isEmailEnabled && isSMSEnabled) {
    placeholder = locale.loginWithPhone;
    emptyErrorMessage = locale.phoneRequired;
    type = "tel";
  }
  if (!isEmailEnabled && !isSMSEnabled && !props.oauthProviders) {
    throw new Error('MagicLink must have either "emailLogin" or "smsLogin" or social login enabled');
  }
  const showInputUI = isEmailEnabled || isSMSEnabled;
  const screen = useScreenContext();
  const showSeparator = props.modalSize === "wide" || screen !== reservedScreens.main && props.modalSize === "compact";
  return /*#__PURE__*/jsxs(Container, {
    flex: "column",
    animate: "fadein",
    gap: props.modalSize === "compact" ? "lg" : "xl",
    style: {
      width: "100%"
    },
    children: [props.oauthProviders && /*#__PURE__*/jsx(Fragment, {
      children: props.oauthProviders.length > 1 ? /*#__PURE__*/jsx(Container, {
        gap: "md",
        flex: "row",
        style: {
          justifyContent: "space-between"
        },
        center: "x",
        children: props.oauthProviders.map(provider => {
          return /*#__PURE__*/jsx(SocialIconButton, {
            onClick: () => {
              props.onSelect({
                provider
              });
            },
            children: /*#__PURE__*/jsx(ToolTip, {
              tip: `${locale.loginWith} ${upperCaseFirstLetter(provider)}`,
              sideOffset: 15,
              children: /*#__PURE__*/jsx(Container, {
                flex: "row",
                center: "both",
                children: /*#__PURE__*/jsx(Img, {
                  src: providerImages[provider],
                  width: iconSize.lg,
                  height: iconSize.lg,
                  alt: ""
                })
              })
            })
          }, provider);
        })
      }) : /*#__PURE__*/jsx(Container, {
        gap: "xs",
        flex: "column",
        children: props.oauthProviders.map(provider => {
          return /*#__PURE__*/jsxs(SocialButtonLarge, {
            variant: "secondary",
            onClick: () => {
              props.onSelect({
                provider
              });
            },
            children: [/*#__PURE__*/jsx(Img, {
              src: providerImages[provider],
              width: iconSize.md,
              height: iconSize.md,
              alt: ""
            }), /*#__PURE__*/jsxs("span", {
              children: [locale.loginWith, " ", upperCaseFirstLetter(provider)]
            })]
          }, provider);
        })
      })
    }), showInputUI && /*#__PURE__*/jsxs(Fragment, {
      children: [showSeparator && /*#__PURE__*/jsx(TextDivider, {
        text: cwLocale.or
      }), /*#__PURE__*/jsx(InputSelectionUI, {
        submitButtonText: locale.submitEmail,
        onSelect: props.onSelect,
        placeholder: placeholder,
        name: "magic-input",
        type: type,
        emptyErrorMessage: emptyErrorMessage,
        errorMessage: input => {
          const isEmail = input.includes("@");
          const isPhone = Number.isInteger(Number(input[input.length - 1]));
          if (isEmail && isEmailEnabled) {
            const emailRegex = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,})$/g;
            const isValidEmail = emailRegex.test(input.replace(/\+/g, ""));
            if (!isValidEmail) {
              return locale.invalidEmail;
            }
          } else if (isPhone && isSMSEnabled) {
            if (!input.startsWith("+")) {
              return locale.countryCodeMissing;
            }
          } else {
            if (isEmailEnabled && isSMSEnabled) {
              return locale.invalidEmailOrPhone;
            }
            if (isEmailEnabled) {
              return locale.invalidEmail;
            }
            if (isSMSEnabled) {
              return locale.invalidPhone;
            }
          }
        }
      })]
    })]
  });
};
function useConnectMagic() {
  const connect = useConnect();
  const connector = useCallback(async data => {
    const {
      selectionData,
      walletConfig,
      singleWallet,
      connected,
      show,
      hide
    } = data;
    if (typeof selectionData === "object") {
      try {
        hide();
        (async () => {
          await connect(walletConfig, {
            oauthProvider: selectionData.provider
          });
        })();
        connected();
      } catch {
        if (!singleWallet) {
          show();
        }
      }
      return;
    }
    const isEmail = selectionData ? selectionData.includes("@") : false;
    (async () => {
      hide();
      try {
        await connect(walletConfig, data.type === "connect" ? {} : isEmail ? {
          email: selectionData
        } : {
          phoneNumber: selectionData
        });
        connected();
      } catch (e) {
        if (!singleWallet) {
          show();
        }
        console.error(e);
      }
    })();
  }, [connect]);
  return connector;
}
const MagicConnectingUI = _ref => {
  let {
    connected,
    walletConfig,
    show,
    selectionData,
    supportedWallets,
    type,
    hide
  } = _ref;
  const connectPrompted = useRef(false);
  const singleWallet = supportedWallets.length === 1;
  const connectMagic = useConnectMagic();
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }
    connectPrompted.current = true;
    connectMagic({
      selectionData: selectionData,
      singleWallet,
      type,
      walletConfig,
      show,
      connected,
      hide
    });
  }, [connectMagic, connected, selectionData, show, singleWallet, type, walletConfig, hide]);
  return /*#__PURE__*/jsx(Container, {
    flex: "row",
    center: "both",
    style: {
      minHeight: "350px"
    },
    children: /*#__PURE__*/jsx(Spinner, {
      size: "xl",
      color: "accentText"
    })
  });
};
const MagicConnectionUIScreen = props => {
  const locale = useTWLocale().wallets.magicLink;
  const connectMagic = useConnectMagic();
  return /*#__PURE__*/jsxs(Container, {
    p: "lg",
    fullHeight: true,
    flex: "column",
    style: {
      minHeight: "300px"
    },
    children: [/*#__PURE__*/jsx(ModalHeader, {
      onBack: props.goBack,
      title: locale.signIn
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsx(Container, {
      expand: true,
      flex: "column",
      center: "both",
      px: props.modalSize === "wide" ? "lg" : undefined,
      children: /*#__PURE__*/jsx(MagicUI, {
        ...props,
        onSelect: data => {
          connectMagic({
            selectionData: data,
            connected: props.connected,
            show: props.show,
            singleWallet: props.supportedWallets.length === 1,
            type: props.type,
            walletConfig: props.walletConfig,
            hide: props.hide
          });
        }
      })
    })]
  });
};
const providerImages = {
  google: googleIconUri,
  facebook: facebookIconUri,
  twitter: twitterIconUri,
  github: githubIconUri,
  apple: appleIconUri,
  linkedin: linkedinIconUri,
  bitbucket: bitbucketIconUri,
  gitlab: gitlabIconUri,
  twitch: twitchIconUri,
  discord: discordIconUri,
  microsoft: microsoftIconUri
};
function upperCaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const SocialButtonLarge = /* @__PURE__ */styled(Button)(() => {
  const theme = useCustomTheme();
  return {
    display: "flex",
    justifyContent: "center",
    gap: spacing.md,
    fontSize: fontSize.md,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: theme.colors.secondaryButtonBg
    },
    "&:active": {
      boxShadow: "none"
    }
  };
});
const SocialIconButton = /* @__PURE__ */styled(IconButton)(() => {
  const theme = useCustomTheme();
  return {
    border: `1px solid ${theme.colors.borderColor}`,
    padding: spacing.sm,
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: theme.colors.accentText,
      background: "transparent"
    },
    flexGrow: 1
  };
});

export { magicLink };
